import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import _ from 'lodash'

import hocScrollbar from 'gnos-scrollbar'

import Tab from './components/Tab'

import { sendMessage } from '../../../../../../services/socket/helpers'
import { SOCKET_ACTION_TYPE } from '../../../../../../services/socket/constants'

import hocConnect from './hocConnect'

import './style.scss'

@hocScrollbar({ smoothScrollbar: true, horizontal: true, overscroll: false })
@hocConnect
export default class Content extends Component {
    static propTypes = {
        activeModule: PropTypes.string.isRequired,
        activeTab: PropTypes.func.isRequired,
        removeTab: PropTypes.func.isRequired,
        removeTabFromOld: PropTypes.func.isRequired,
        tabs: IPropTypes.list.isRequired,
    }

    onTabClick = (tabId, tabType) => {
        const { activeTab } = this.props

        activeTab(tabId, tabType)
    }

    onTabCloseClick = (tabId, tabType) => {
        const { removeTab } = this.props

        removeTab(tabId, tabType)
        sendMessage(SOCKET_ACTION_TYPE.CLOSE_NEW_TAB, { module: tabType, entId: tabId })
    }

    onTabFromOldClick = (tabId, tabType) => {
        const moduleName = tabType === 'reportOld' ? 'report' : tabType

        sendMessage(SOCKET_ACTION_TYPE.SHOW_MODULE_OUTPUT, { module: moduleName, entityId: tabId })
    }

    onTabFromOldCloseClick = (tabId, tabType, index) => {
        const { removeTabFromOld } = this.props
        const entId = _.isNaN(_.toNumber(tabId)) ? tabId : _.toNumber(tabId)

        removeTabFromOld(tabId, tabType)
        sendMessage(SOCKET_ACTION_TYPE.CLOSE_TAB, {
            tab: { index, module: tabType, entId, fromNew: false },
        })
    }

    renderTabs = () => {
        const { tabs, activeModule } = this.props

        const tabComponents = tabs
            .map((tab, index) => {
                const fromOld = tab.get('fromOld', false)

                return (
                    <Tab
                        key={`${tab.get('type')}_${tab.get('id')}`}
                        id={tab.get('id')}
                        text={tab.get('text')}
                        type={tab.get('type')}
                        index={index}
                        active={activeModule === tab.get('type') && tab.get('active')}
                        onClick={!fromOld ? this.onTabClick : this.onTabFromOldClick}
                        onCloseClick={!fromOld ? this.onTabCloseClick : this.onTabFromOldCloseClick}
                    />
                )
            })
            .toArray()

        return tabComponents
    }

    render() {
        return <div className={'workspace-tabs-content'}>{this.renderTabs()}</div>
    }
}
